<template>
  <div class="_container">
    <div class="_header">
      <div class="header_title" v-text="$t('utils.controlList')" />
      <BaseButton
        icon="$mdiFileCog"
        type="primary"
        @click="importDialogOpen = true"
      >
        {{ $t("utils.create") }}
      </BaseButton>
    </div>
    <BaseDataTable
      :items="controls.items"
      :loading="loading"
      :options="{
        page: filters.page,
        itemsPerPage: filters.page_size,
      }"
      :server-items-length="controls.count"
      :loading-text="$t('utils.loadingData')"
      @update:options="onPaginationChange"
    >
      <template #header>
        <thead>
          <tr>
            <th>
              {{ $t("utils.title") }}
            </th>

            <th>
              {{ $t("utils.externalId") }}
            </th>

            <th>
              {{ $t("controls.fields_to_control") }}
            </th>
            <th>
              {{ $t("utils.actions") }}
            </th>
          </tr>
        </thead>
      </template>
      <template #item="{ item }">
        <tr class="tab_row">
          <td>
            <div class="row_item">
              {{ item.name }}
            </div>
          </td>
          <td>
            <div class="row_item">
              {{ item.externalId }}
            </div>
          </td>
          <td>
            <div class="row_item">
              <div class="item_label">
                {{
                  item.questionTemplates.length
                    ? item.questionTemplates.map((q) => q.name).join(",")
                    : "--"
                }}
              </div>
            </div>
          </td>
          <td>
            <div class="action_section">
              <BaseButtonIcon
                small
                color="primary"
                icon="$mdiPencilOutline"
                @click="editControlTemplate(item)"
              />
              <BaseButtonIcon
                small
                color="error"
                icon="$mdiTrashCanOutline"
                @click="removeControlTemplate(item)"
              />
            </div>
          </td>
        </tr>
      </template>
    </BaseDataTable>
    <ControlCreateAndEditDialog
      v-if="importDialogOpen"
      :organization-id="organizationId"
      :control="selectedControl"
      @close="onCloseControlCreateDialog"
      @fetch-controls="fetchcontrols"
    />
    <ControlDeleteDialog
      v-if="removeDialogOpen"
      :selected-control="selectedControl"
      @close="removeDialogOpen = false"
      @control-deleted="deleteControl"
    />
  </div>
</template>

<script>
import OrganizationAPI from "@/core/Services/organization.api";
import ControlCreateAndEditDialog from "../Components/ControlCreateAndEditDialog.vue";
import ControlDeleteDialog from "../Components/ControlDeleteDialog.vue";
export default {
  name: "ControlList",
  components: {
    ControlCreateAndEditDialog,
    ControlDeleteDialog,
  },
  props: {
    organizationId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      importDialogOpen: false,
      removeDialogOpen: false,
      selectedControl: null,
      controls: {
        items: [],
        count: 0,
      },
      loading: true,
      filters: {
        page_size: 10,
        page: 1,
      },
    };
  },
  methods: {
    async fetchcontrols() {
      this.loading = true;
      try {
        const response = await OrganizationAPI.getOrganizationValidationSchema({
          organizationId: this.organizationId,
          filters: this.filters,
        });
        this.controls = {
          ...response.data,
          items: response.data.results,
        };
      } catch {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.errorHasHappen"),
          type: "ERROR",
        });
      }
      this.loading = false;
    },
    onPaginationChange(pagination) {
      this.filters.page = pagination.page;
      this.filters.page_size =
        pagination.itemsPerPage < 0
          ? this.controls.count
          : pagination.itemsPerPage;
      this.fetchcontrols();
    },
    editControlTemplate(item) {
      this.selectedControl = item;
      this.importDialogOpen = true;
    },
    onCloseControlCreateDialog() {
      this.importDialogOpen = false;
      this.selectedControl = null;
    },
    removeControlTemplate(item) {
      this.selectedControl = item;
      this.removeDialogOpen = true;
    },
    deleteControl() {
      this.controls.items.splice(
        this.controls.items.findIndex(
          (item) => item.id == this.selectedControl.id
        ),
        1
      );
      this.selectedControl = null;
    },
  },
};
</script>

<style scoped lang="scss">
._container {
  ._header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 32px;
    gap: 16px;
    .header_title {
      font-weight: 600;
      font-size: 24px;
      line-height: 30px;
      color: #353542;
      margin-top: 8px;
      margin-right: auto;
    }
  }
  .tab_row {
    .row_item {
      padding: 16px 0;
      font-family: "Inter";
      font-style: normal;
      .item_label {
        color: #2536cc;
        font-size: 12px;
        font-weight: 600;
        line-height: 20px;
        cursor: pointer;
        width: clamp(200px, 500px, 50%);
      }
    }
    .action_section {
      display: flex;
      align-items: center;
      gap: 4px;
    }
  }
}
</style>
